import styled from 'styled-components';

export const Nav = styled.nav`
  background: ${({ $scrolled }) => ($scrolled ? 'rgba(10, 10, 25, 0.85)' : 'rgba(10, 10, 25, 0.6)')};
  height: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid ${({ $scrolled }) => ($scrolled ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.06)')};
  box-shadow: ${({ $scrolled }) => ($scrolled ? '0 10px 30px -10px rgba(0, 0, 0, 0.5)' : 'none')};
  transition: all 0.3s ease-in-out;
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;

  @media screen and (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const NavLogo = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
  font-size: 20px;
  color: ${({ theme }) => theme.text_primary || '#ffffff'};
  cursor: pointer;
  letter-spacing: -0.5px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  transition: all 0.3s ease;

  span {
    color: #8b5cf6;
    margin-left: 2px;
  }

  &:hover {
    transform: translateY(-1px);
    opacity: 0.9;
  }
`;

export const NavItems = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  list-style: none;

  @media screen and (max-width: 860px) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.7)')};
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '500')};
  font-size: 15px;
  cursor: pointer;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 20px;
  background: ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.12)' : 'transparent')};
  border: 1px solid ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.18)' : 'transparent')};
  transition: all 0.25s cubic-bezier(0.23, 1, 0.32, 1);
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-1px);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  @media screen and (max-width: 860px) {
    display: none;
  }
`;

export const GithubButton = styled.a`
  border: 1px solid rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }
`;

export const MobileIcon = styled.button`
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 24px;
  padding: 8px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media screen and (max-width: 860px) {
    display: flex;
  }
`;

export const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: absolute;
  top: 72px;
  left: 0;
  right: 0;
  width: 100%;
  padding: 24px 20px 32px 20px;
  background: rgba(13, 15, 30, 0.96);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  z-index: 99;

  @media screen and (min-width: 861px) {
    display: none;
  }
`;

export const MobileMenuLink = styled.a`
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.8)')};
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '500')};
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 24px;
  width: 80%;
  max-width: 280px;
  text-align: center;
  border-radius: 16px;
  background: ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.12)' : 'rgba(255, 255, 255, 0.03)')};
  border: 1px solid ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.06)')};
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
  }
`;
